import React, { useState } from 'react';
import { Nav, Tab } from 'react-bootstrap';
import moment from 'moment';
import { FaClock } from 'react-icons/fa';

const ScreenshotViewer = ({ groupedScreenshots, shots, toggleEdit }) => {
  const [activeTab, setActiveTab] = useState('hourly');

  const renderHourlyScreenshots = () => (
    <div className="hourly-screenshots">
      {Object.keys(groupedScreenshots).length > 0 ? (
        Object.entries(groupedScreenshots).map(([hour, screenshots]) => (
          <div key={hour} className="hour-group">
            <h5 className="hour-title">
              {moment(hour, 'HH:mm').format('h:mm A')}
            </h5>
            <div className="screenshot-row">
              {screenshots.map((screenshot, idx) => (
                <ScreenshotCard
                  key={idx}
                  screenshot={screenshot}
                  toggleEdit={toggleEdit}
                />
              ))}
            </div>
          </div>
        ))
      ) : (
        <div className="empty-state">No Screenshots Found</div>
      )}
    </div>
  );

  const renderAllScreenshots = () => (
    <div className="all-screenshots">
      {shots?.screenshots?.length > 0 ? (
        <div className="screenshot-grid">
          {shots.screenshots
            .sort(
              (a, b) =>
                new Date(a?.media?.createdAt) - new Date(b?.media?.createdAt)
            )
            .map((screenshot, idx) => (
              <ScreenshotCard
                key={idx}
                screenshot={screenshot}
                toggleEdit={toggleEdit}
              />
            ))}
        </div>
      ) : (
        <div className="empty-state">No Screenshots Found</div>
      )}
    </div>
  );

  return (
    <div className="screenshot-gallery">
      <Nav variant="tabs" className="mb-3">
        <Nav.Item>
          <Nav.Link
            className={activeTab === 'hourly' ? 'active' : ''}
            onClick={() => setActiveTab('hourly')}
          >
            Every 1 hour
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link
            className={activeTab === 'all' ? 'active' : ''}
            onClick={() => setActiveTab('all')}
          >
            All Screenshots
          </Nav.Link>
        </Nav.Item>
      </Nav>

      <Tab.Content>
        <Tab.Pane active={activeTab === 'hourly'}>
          {renderHourlyScreenshots()}
        </Tab.Pane>
        <Tab.Pane active={activeTab === 'all'}>
          {renderAllScreenshots()}
        </Tab.Pane>
      </Tab.Content>
    </div>
  );
};

const ScreenshotCard = ({ screenshot, toggleEdit }) => (
  <div className="screenshot-card" onClick={() => toggleEdit(screenshot)}>
    <div className="screenshot-header">
      <div className="project-name text-capitalize">
        {screenshot?.projectTaskActivity?.projectTask?.project?.name}
      </div>

      <div className="screenshot-footer d-flex align-items-center justify-content-between">
        <small>Employee's Timezone: </small>
        <small>{screenshot?.timezone}</small>
      </div>
    </div>

    <div className="screenshot-image">
      <img
        src={screenshot?.media?.url || '/placeholder.svg'}
        alt="Screenshot"
      />
      <div className="screenshot-overlay">
        <FaClock /> {moment(screenshot.createdAt).format('h:mm A')}
      </div>
    </div>
  </div>
);

export default ScreenshotViewer;
